import Vue from '../../lib/utils/vue'
import * as getters from '../../../builder/src/js/store/modules/getters'
import * as mutations from '../../../builder/src/js/store/modules/mutations'
import * as actions from '../../../builder/src/js/store/modules/actions'

import CvtRadioGroup from '../molecules/radio-group/RadioGroup'
import CvtRadioButton from '../molecules/radio-group/RadioButton'
import CvtRadio from '../molecules/radio-group/Radio'

import CvtSelect from '../molecules/Select'
import Button from '../molecules/Button'
import CvtInput from '../molecules/Input'

import { styled, VueEmotion } from '@egoist/vue-emotion'
import { mapGetters, mapState, mapActions } from '../../../builder/node_modules/vuex'
import VueI18n from 'vue-i18n'

Vue.use(VueEmotion)
Vue.use(VueI18n)

let Spacing, Radii, Border, Colors, textLineHeight, BorderStyle, textFontWeight, borderColor, backgroundColor, textFontSize, textColor, FontFamily, FontSize, FontWeight;

const getElementWrapper = () => styled('div')`

  font-family: ${FontFamily.DEFAULT};
  ${textColor({ themeing: 'dark' }, 500)}

  ${(props) => {

    let style = ``;

    if(props.height) {
      style += `height: ${props.height};`
    }

    if(props.width) {
      style += `width: ${props.width};`
    }

    return style;
  }}
`

const getMainWrapper = () => styled('div')`
  width: 100%;
`

const getSectionWrapper = () => styled('div')`
  height: auto;
  min-height: ${Spacing.SPACING_96}px;
  margin-top: ${Spacing.SPACING_32}px;
  display: flex;
  justify-content: start;
  align-items: start;
`

const getSectionLeftHeading = () => styled('div')`
  font-size: ${FontSize.FONT_SIZE_14}px;
  font-weight: ${FontWeight.SEMI_BOLD};
  font-family: ${FontFamily.DEFAULT};
  ${textColor({ themeing: 'dark' }, 500)}
  ${textLineHeight('xl')}
  width: ${Spacing.SPACING_128 + Spacing.SPACING_64 + Spacing.SPACING_24}px;
`

const getSectionRightContentWrapper = () => styled('div')`
  width: 100%;
  padding-bottom: ${Spacing.SPACING_32}px;
  border-bottom-width: ${Border.SIZE_1}px;
  border-bottom-style: solid;
  border-bottom-color: ${Colors.BASIC[200]};
`

const getSectionRightContentHeading = () => styled('div')`
  font-size: ${FontSize.FONT_SIZE_14}px;
  font-weight: ${FontWeight.REGULAR};
  font-family: ${FontFamily.DEFAULT};
  ${textColor({ themeing: 'dark' }, 400)}
  ${textLineHeight('xl')}
  margin-bottom: ${Spacing.SPACING_16}px;
`

const getSpecificOptionContentWrapper = () => styled('div')`
  width: 100%;
  margin-top: ${Spacing.SPACING_32}px; 
  padding: ${Spacing.SPACING_24}px ${Spacing.SPACING_12}px;
  border: ${Border.SIZE_1}px solid ${Colors.BASIC[200]};
  border-radius: ${4 * Border.SIZE_1}px;
`

const getSpecificOptionHeading = () => styled('div')`
  font-size: ${FontSize.FONT_SIZE_14}px;
  font-weight: ${FontWeight.REGULAR};
  font-family: ${FontFamily.DEFAULT};
  ${textColor({ themeing: 'dark' }, 400)}
  ${textLineHeight('xl')}
  margin-bottom: ${Spacing.SPACING_16}px;
`

const getSpecificOptionInnerWrapper = () => styled('div')`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: start;
`

const getSpecificOptionSelectInnerWrapper = () => styled('div')`
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
`

const getSpecificOptionPlusBtnInnerWrapper = () => styled('div')`
  width: 30px;
  height: 40px;
  display: flex;
  justify-content: end;
  align-items: center;
`

const getPlusButton = () => styled(Button)`
  font-family: ${FontFamily.DEFAULT};
  text-align: center;
  font-style: normal;
`

const getQuestionMarkButton = () => styled(Button)`
  font-family: ${FontFamily.DEFAULT};
  text-align: center;
  font-style: normal;
`

const getMinusButton = () => styled(Button)`
  font-family: ${FontFamily.DEFAULT};
  text-align: center;
  font-style: normal;
`

const getImportLink = () => styled(Button)`
  font-family: ${FontFamily.DEFAULT};
  text-align: center;
  font-style: normal;
  border-right-width: ${Border.SIZE_1}px;
  border-right-style: solid;
  border-right-color: ${Colors.BASIC[200]};
`

const getAddLink = () => styled(Button)`
  font-family: ${FontFamily.DEFAULT};
  text-align: center;
  font-style: normal;
`

const getTimeFrameWrapper = () => styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const getTimeFrameInnerWrapperOne = () => styled('div')`
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  padding-bottom: ${Spacing.SPACING_16}px;
  border-bottom: ${Border.SIZE_1}px solid ${Colors.BASIC[200]};
  gap: 7px;
`

const getTimeFrameInnerWrapperTwo = () => styled('div')`
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  margin-top: ${Spacing.SPACING_16 + Spacing.SPACING_4}px;
  gap: 7px;
`

const getPageScrollWrapper = () => styled('div')`
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 7px;
`

const getExitIntentWrapper = () => styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const getExitIntentInnerWrapperOne = () => styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;
`

const getExitIntentInnerWrapperTwo = () => styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: ${Spacing.SPACING_16 + Spacing.SPACING_4}px;
`

const getExitIntentInnerWrapperOneSubSection = () => styled('div')`
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  padding-bottom: ${Spacing.SPACING_16}px;
  padding-left: ${Spacing.SPACING_18 + Spacing.SPACING_2}px;
  border-bottom: ${Border.SIZE_1}px solid ${Colors.BASIC[200]};
  gap: 7px;
`

const getRadioGroup = () => styled(CvtRadioGroup)``

const getRadio = () => styled(CvtRadio)``

const getExitIntentInnerWrapperOneHeading = () => styled('div')`
  width: 100%;
  font-size: ${FontSize.FONT_SIZE_14}px;
  font-weight: ${FontWeight.REGULAR};
  font-family: ${FontFamily.DEFAULT};
  ${textColor({ themeing: 'dark' }, 400)}
  ${textLineHeight('xl')}
  padding-left: ${Spacing.SPACING_18 + Spacing.SPACING_2}px;
  margin-bottom: ${Spacing.SPACING_16}px;
`

const getExitIntentInnerWrapperTwoHeadingWrap = () => styled('div')`
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 7px;
`

const getExitIntentInnerWrapperTwoHeading = () => styled('div')`
  font-size: ${FontSize.FONT_SIZE_14}px;
  font-weight: ${FontWeight.REGULAR};
  font-family: ${FontFamily.DEFAULT};
  ${textColor({ themeing: 'dark' }, 400)}
  ${textLineHeight('xl')}
  padding-left: ${Spacing.SPACING_18 + Spacing.SPACING_2}px;
  margin-bottom: ${Spacing.SPACING_16}px;
`

const getExitIntentInnerWrapperTwoSubHeading = () => styled('a')`
  font-size: ${FontSize.FONT_SIZE_14}px;
  font-weight: ${FontWeight.REGULAR};
  font-family: ${FontFamily.DEFAULT};
  ${textColor({ themeing: 'primary' }, 500)}
  ${textLineHeight('xl')}
  margin-bottom: ${Spacing.SPACING_16}px;
`

const getMousePointerWrapper = () => styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const getMousePointerHeading = () => styled('div')`
  font-size: ${FontSize.FONT_SIZE_14}px;
  font-weight: ${FontWeight.REGULAR};
  font-family: ${FontFamily.DEFAULT};
  ${textColor({ themeing: 'dark' }, 400)}
  ${textLineHeight('xl')}
  margin-bottom: ${Spacing.SPACING_16}px;
  padding-left: ${Spacing.SPACING_18 + Spacing.SPACING_2}px;
`


const getMousePointerInnerWrapperOne = () => styled('div')`
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  margin-top: ${Spacing.SPACING_16}px;
  padding-left: ${Spacing.SPACING_18 + Spacing.SPACING_2}px;
  gap: 7px;
`

const getMousePointerInnerWrapperTwo = () => styled('div')`
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
`

const getSelectCssButton = () => styled(Button)``

const getEventWrapper = () => styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;
`

const getEventHeading = () => styled('div')`
  font-size: ${FontSize.FONT_SIZE_14}px;
  font-weight: ${FontWeight.REGULAR};
  font-family: ${FontFamily.DEFAULT};
  ${textColor({ themeing: 'dark' }, 400)}
  ${textLineHeight('xl')}
  margin-bottom: ${Spacing.SPACING_16}px;
  padding-left: ${Spacing.SPACING_18 + Spacing.SPACING_2}px;
`

const getEventInnerWrapperOne = () => styled('div')`
  width: 410px;
  display: flex;
  justify-content: start;
  align-items: end;
  gap: 7px;
`

const getEventInnerWrapperOneSubSectionOne = () => styled('div')`
  width: 350px;
  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;
  margin-top: ${Spacing.SPACING_16}px;
  padding-left: ${Spacing.SPACING_18 + Spacing.SPACING_2}px;
  gap: 7px;
`

const getEventInnerWrapperOneSubSectionTwo = () => styled('div')`
  display: flex;
  justify-content: start;
  align-items: center;
  padding-bottom: ${Spacing.SPACING_4}px;
`

const getEventInnerWrapperTwo = () => styled('div')`
  width: 386px;
  display: flex;
  justify-content: start;
  align-items: center;
  margin-top: ${Spacing.SPACING_12}px;
`

const getEventInnerWrapperTwoSubSectionOne = () => styled('div')`
  width: 100%;
  display: flex;
  justify-content: end;
  align-items: center;
  padding-bottom: ${Spacing.SPACING_4}px;
`

const getEventInnerWrapperThree = () => styled('div')`
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  padding-left: ${Spacing.SPACING_18 + Spacing.SPACING_2}px;
  gap: 7px;
`

const getPlacementTypeInnerWrapperOne = () => styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;
  border-bottom: ${Border.SIZE_1}px solid ${Colors.BASIC[200]};
  padding-bottom: ${Spacing.SPACING_16}px;
`

const getPlacementTypeInnerWrapperTwo = () => styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: ${Spacing.SPACING_18 + Spacing.SPACING_2}px;
`

const getPlacementTypeAddImportWrapper = () => styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 7px;
`

const getFrequencyTypeWrapper = () => styled('div')`
  width: 100%;
  padding-bottom: ${Spacing.SPACING_32}px;
`

export const CvtSapRules = {
  name: 'CvtSapRules',
  components: {
    CvtRadioGroup,
    CvtRadioButton,
    CvtSelect,
    CvtInput
  },
  data () {
    return {
      triggerType: 'time-frame',
      placementType: 'all-pages',
      frequencyType: 'once-per-page-load',
    }
  },
  props: {
    mode: {
      type: String,
      default: 'LIGHT',
      required: false
    },
    
  },
  computed: {
    ...mapGetters ('globalTheme', {
      textFontWeight: getters.GLOBAL_STYLE_FONT_WEIGHT,
      textColor: getters.GLOBAL_STYLE_COLOR,
      borderColor: getters.GLOBAL_STYLE_BORDER_COLOR,
      backgroundColor: getters.GLOBAL_STYLE_BACKGROUND_COLOR,
      textFontSize: getters.GLOBAL_STYLE_FONT_SIZE,
      textLineHeight: getters.GLOBAL_STYLE_LINE_HEIGHT,
    }),
    ...mapState ('globalTheme', {
      Spacing: ({ globalTheme }) => globalTheme.Spacing,
      Radii: ({ globalTheme }) => globalTheme.Radii,
      Border: ({ globalTheme }) => globalTheme.Border,
      Colors: ({ globalTheme }) => globalTheme.Colors,
      FontFamily: ({ globalTheme }) => globalTheme.FontFamily,
      FontWeight: ({ globalTheme }) => globalTheme.FontWeight,
      BorderStyle: ({ globalTheme }) => globalTheme.BorderStyle,
      FontSize: ({ globalTheme }) => globalTheme.FontSize,
      FontWeight: ({ globalTheme }) => globalTheme.FontWeight,
      orgName: ({ globalTheme }) => globalTheme?.OrgName !== undefined ? globalTheme.OrgName : LEFT_SIDEBAR_STANDARD,
    }),
    
  },
  created () {
    Spacing = this.Spacing
    Radii = this.Radii
    Border = this.Border
    Colors = this.Colors
    BorderStyle = this.BorderStyle
    FontFamily = this.FontFamily
    textFontWeight = this.textFontWeight
    borderColor = this.borderColor
    textColor = this.textColor
    backgroundColor = this.backgroundColor
    textFontSize = this.textFontSize
    textLineHeight = this.textLineHeight
    FontSize = this.FontSize
    FontWeight = this.FontWeight
  },
  methods: {
    ...mapActions ({}),
    onTriggerTypeChange(value) {
      this.triggerType = value;
    },
    onPlacementTypeChange(value) {
      this.placementType = value;
    },
    onFrequencyTypeChange(value) {
      this.frequencyType = value;
    },
  },
  mounted () {
  },
  render: function (h) {

    const ElementWrapper                          = getElementWrapper()

    const MainWrapper                             = getMainWrapper()

    const SectionWrapper                          = getSectionWrapper()
    const SectionLeftHeading                      = getSectionLeftHeading()
    const SectionRightContentWrapper              = getSectionRightContentWrapper()
    const SectionRightContentHeading              = getSectionRightContentHeading()

    
    const SpecificOptionContentWrapper            = getSpecificOptionContentWrapper()
    const SpecificOptionHeading                   = getSpecificOptionHeading()

    const SpecificOptionInnerWrapper              = getSpecificOptionInnerWrapper()
    const SpecificOptionSelectInnerWrapper        = getSpecificOptionSelectInnerWrapper()
    const SpecificOptionPlusBtnInnerWrapper       = getSpecificOptionPlusBtnInnerWrapper()

    const PlusButton                              = getPlusButton();
    const MinusButton                             = getMinusButton();
    const QuestionMarkButton                      = getQuestionMarkButton();
    const ImportLink                              = getImportLink();
    const AddLink                                 = getAddLink();

    const RadioGroup                              = getRadioGroup()
    const Radio                                   = getRadio()
    
    const SelectCssButton                         = getSelectCssButton()

    const TimeFrameWrapper                        = getTimeFrameWrapper()
    const TimeFrameInnerWrapperOne                = getTimeFrameInnerWrapperOne()
    const TimeFrameInnerWrapperTwo                = getTimeFrameInnerWrapperTwo()

    const PageScrollWrapper                       = getPageScrollWrapper()

    const ExitIntentWrapper                       = getExitIntentWrapper()
    const ExitIntentInnerWrapperOneHeading        = getExitIntentInnerWrapperOneHeading()
    const ExitIntentInnerWrapperOne               = getExitIntentInnerWrapperOne()
    const ExitIntentInnerWrapperOneSubSection     = getExitIntentInnerWrapperOneSubSection()

    const ExitIntentInnerWrapperTwo               = getExitIntentInnerWrapperTwo()
    const ExitIntentInnerWrapperTwoHeadingWrap    = getExitIntentInnerWrapperTwoHeadingWrap()
    const ExitIntentInnerWrapperTwoHeading        = getExitIntentInnerWrapperTwoHeading()
    const ExitIntentInnerWrapperTwoSubHeading     = getExitIntentInnerWrapperTwoSubHeading()

    const MousePointerWrapper                     = getMousePointerWrapper()
    const MousePointerHeading                     = getMousePointerHeading()
    const MousePointerInnerWrapperOne             = getMousePointerInnerWrapperOne()
    const MousePointerInnerWrapperTwo             = getMousePointerInnerWrapperTwo()

    const EventWrapper                            = getEventWrapper()
    const EventHeading                            = getEventHeading()
    const EventInnerWrapperOne                    = getEventInnerWrapperOne()
    const EventInnerWrapperOneSubSectionOne       = getEventInnerWrapperOneSubSectionOne()
    const EventInnerWrapperOneSubSectionTwo       = getEventInnerWrapperOneSubSectionTwo()
    const EventInnerWrapperTwo                    = getEventInnerWrapperTwo()
    const EventInnerWrapperTwoSubSectionOne       = getEventInnerWrapperTwoSubSectionOne()

    const EventInnerWrapperThree                  = getEventInnerWrapperThree()

    const PlacementTypeInnerWrapperOne            = getPlacementTypeInnerWrapperOne()
    const PlacementTypeInnerWrapperTwo            = getPlacementTypeInnerWrapperTwo()
    const PlacementTypeAddImportWrapper           = getPlacementTypeAddImportWrapper()

    const FrequencyTypeWrapper                    = getFrequencyTypeWrapper()

    return (
      <MainWrapper>


        <SectionWrapper>
          <SectionLeftHeading>Triggers</SectionLeftHeading>

          <SectionRightContentWrapper>
            <SectionRightContentHeading>Which visitor will trigger your campaign</SectionRightContentHeading>

            <ElementWrapper>
              <cvt-radio-group 
                theme={"LIGHT"} 
                orientation={'horizontal'} 
                initialValue={this.triggerType}
              >

                <cvt-radio-button 
                  size={"md"} 
                  value={'time-frame'}
                  supportText={'Time Frame'} 
                  onRadioClick={(value) => this.onTriggerTypeChange(value)}
                >
                  <cvt-icon icon="clock"></cvt-icon>
                </cvt-radio-button>

                <cvt-radio-button 
                  size={"md"} 
                  value={'page-scroll'} 
                  supportText={'Page Scroll'} 
                  onRadioClick={(value) => this.onTriggerTypeChange(value)}
                >
                  <cvt-icon icon="arrow-down"></cvt-icon>
                </cvt-radio-button>

                <cvt-radio-button 
                  size={"md"} 
                  value={'exit-intent'} 
                  supportText={'Exit Intent'} 
                  onRadioClick={(value) => this.onTriggerTypeChange(value)}
                >
                  <cvt-icon icon="external-link-alt"></cvt-icon>
                </cvt-radio-button>

                <cvt-radio-button 
                  size={"md"} 
                  value={'mouse-pointer'} 
                  supportText={'Mouse'} 
                  onRadioClick={(value) => this.onTriggerTypeChange(value)}
                >
                  <cvt-icon icon="mouse-pointer"></cvt-icon>
                </cvt-radio-button>

                <cvt-radio-button 
                  size={"md"} 
                  value={'event'} 
                  supportText={'Event'} 
                  onRadioClick={(value) => this.onTriggerTypeChange(value)}
                >
                  <cvt-icon icon="code"></cvt-icon>
                </cvt-radio-button>

              </cvt-radio-group>
            </ElementWrapper>

            { this.triggerType === 'time-frame' && (
              <SpecificOptionContentWrapper>

                <SpecificOptionHeading>Select when to open your campaign</SpecificOptionHeading>

                <TimeFrameWrapper>

                  <TimeFrameInnerWrapperOne>

                    <ElementWrapper
                      width={'auto'}
                    >
                      Open campaign
                    </ElementWrapper>

                    <ElementWrapper
                        width={'100px'}
                      >
                      <cvt-select 
                        value={'5'}
                        label={""} 
                        helpText={""}
                        multiple={false}
                        mode={'dropdown'}
                        backgroundMode={this.mode}
                        selectDisabled={false}
                        floatingLabel={true}
                        onInput={() => {}}
                      >
                        <option value={"5"}>5</option>
                        <option value={"4"}>4</option>
                        <option value={"3"}>3</option>
                        <option value={"2"}>2</option>
                        <option value={"1"}>1</option>
                      </cvt-select>
                    </ElementWrapper>

                    <ElementWrapper
                      width={'auto'}
                    >
                      Second after page loads
                    </ElementWrapper>

                    <ElementWrapper
                        width={'190px'}
                      >
                      <cvt-select 
                        value={'specific-pages'}
                        label={""} 
                        helpText={""}
                        multiple={false}
                        mode={'dropdown'}
                        backgroundMode={this.mode}
                        selectDisabled={false}
                        floatingLabel={true}
                        onInput={() => {}}
                      >
                        <option value={"specific-pages"}>Specific Pages</option>
                        <option value={"lorem-ipsum"}>Lorem Ipsum</option>
                        <option value={"dollar-sit"}>Dollar Sit</option>
                      </cvt-select>
                    </ElementWrapper>

                  </TimeFrameInnerWrapperOne>
                  
                  <TimeFrameInnerWrapperTwo>

                    <ElementWrapper
                      width={'auto'}
                    >
                      Time to show up after the user is back to the location page
                    </ElementWrapper>

                    <ElementWrapper
                        width={'100px'}
                      >
                      <cvt-select 
                        value={'5'}
                        label={""} 
                        helpText={""}
                        multiple={false}
                        mode={'dropdown'}
                        backgroundMode={this.mode}
                        selectDisabled={false}
                        floatingLabel={true}
                        onInput={() => {}}
                      >
                        <option value={"5"}>5</option>
                        <option value={"4"}>4</option>
                        <option value={"3"}>3</option>
                        <option value={"2"}>2</option>
                        <option value={"1"}>1</option>
                      </cvt-select>
                    </ElementWrapper>

                    <ElementWrapper
                      width={'auto'}
                    >
                      Seconds
                    </ElementWrapper>

                  </TimeFrameInnerWrapperTwo>

                </TimeFrameWrapper>

              </SpecificOptionContentWrapper>
            )}

            { this.triggerType === 'page-scroll' && (
              <SpecificOptionContentWrapper>

                <SpecificOptionHeading>Select when to open your campaign</SpecificOptionHeading>

                <PageScrollWrapper>

                  <ElementWrapper
                    width={'auto'}
                  >
                    Open campaign after visitor scrolls
                  </ElementWrapper>

                  <ElementWrapper
                      width={'100px'}
                  >
                    <cvt-select 
                      value={'5'}
                      label={""} 
                      helpText={""}
                      multiple={false}
                      mode={'dropdown'}
                      backgroundMode={this.mode}
                      selectDisabled={false}
                      floatingLabel={true}
                      onInput={() => {}}
                    >
                      <option value={"5"}>5</option>
                      <option value={"4"}>4</option>
                      <option value={"3"}>3</option>
                      <option value={"2"}>2</option>
                      <option value={"1"}>1</option>
                    </cvt-select>
                  </ElementWrapper>

                  <ElementWrapper
                      width={'100px'}
                  >
                    <cvt-select 
                      value={'px'}
                      label={""} 
                      helpText={""}
                      multiple={false}
                      mode={'dropdown'}
                      backgroundMode={this.mode}
                      selectDisabled={false}
                      floatingLabel={true}
                      onInput={() => {}}
                    >
                      <option value={"px"}>px</option>
                      <option value={"rem"}>rem</option>
                      <option value={"em"}>em</option>
                      <option value={"%"}>%</option>
                    </cvt-select>
                  </ElementWrapper>

                  <ElementWrapper
                    width={'auto'}
                  >
                    Of the entire page
                  </ElementWrapper>

                </PageScrollWrapper>

              </SpecificOptionContentWrapper>
            )}

            { this.triggerType === 'exit-intent' && (
              <SpecificOptionContentWrapper>

                <ExitIntentWrapper>

                  <ExitIntentInnerWrapperOne>

                    <ExitIntentInnerWrapperOneHeading>Select when to open your campaign</ExitIntentInnerWrapperOneHeading>

                    <ElementWrapper
                      width={'auto'}
                    >
                      <RadioGroup 
                        theme={''}
                        orientation={'vertical'}
                        size={'md'}
                        initialValue={'immediately'}
                      >
                        <Radio
                          border={false} 
                          otherValue={'immediately'}
                          onRadioClick={(val) => {}}
                        >
                          Open campaign immediately when a visitor tries to leave your site
                        </Radio>
                        <Radio
                          border={false} 
                          otherValue={'within_timeframe'}
                          onRadioClick={(val) => {}}
                        >
                          Enable the campaign to open when a visitor tries to leave, but within a time frame
                        </Radio>

                      </RadioGroup>

                    </ElementWrapper>

                    <ExitIntentInnerWrapperOneSubSection>

                      <ElementWrapper
                        width={'auto'}
                      >
                        When the user exists, wait
                      </ElementWrapper>

                      <ElementWrapper
                        width={'70px'}
                      >
                        <cvt-select
                          value={'5'}
                          label={""} 
                          helpText={""}
                          multiple={false}
                          mode={'dropdown'}
                          backgroundMode={this.mode}
                          selectDisabled={false}
                          floatingLabel={true}
                          onInput={() => {}}
                        >
                          <option value={"5"}>5</option>
                          <option value={"4"}>4</option>
                          <option value={"3"}>3</option>
                          <option value={"2"}>2</option>
                          <option value={"1"}>1</option>
                        </cvt-select>

                      </ElementWrapper>

                      <ElementWrapper
                        width={'auto'}
                      >
                        seconds before displaying the campaign
                      </ElementWrapper>


                    </ExitIntentInnerWrapperOneSubSection>
                  
                  </ExitIntentInnerWrapperOne>
                  
                  <ExitIntentInnerWrapperTwo>

                    <ExitIntentInnerWrapperTwoHeadingWrap>

                      <ExitIntentInnerWrapperTwoHeading>Select when to open your campaign on mobile devices</ExitIntentInnerWrapperTwoHeading>
                      <ExitIntentInnerWrapperTwoSubHeading>Learn More</ExitIntentInnerWrapperTwoSubHeading>

                    </ExitIntentInnerWrapperTwoHeadingWrap>

                    <ElementWrapper
                      width={'100%'}
                    >
                      <RadioGroup 
                        theme={''}
                        orientation={'vertical'}
                        size={'md'}
                        initialValue={'scroll_up_page'}
                      >
                        <Radio
                          border={false} 
                          otherValue={'scroll_up_page'}
                          onRadioClick={(val) => {}}
                        >
                          Scroll up the page
                        </Radio>
                        <Radio
                          border={false} 
                          otherValue={'clicking_back_btn'}
                          onRadioClick={(val) => {}}
                        >
                          Clicking back button until the previous visited site
                        </Radio>

                      </RadioGroup>

                    </ElementWrapper>

                  </ExitIntentInnerWrapperTwo>

                </ExitIntentWrapper>

              </SpecificOptionContentWrapper>
            )}

            { this.triggerType === 'mouse-pointer' && (
              <SpecificOptionContentWrapper>

                <MousePointerHeading>Copy the CSS selector of the HTML element</MousePointerHeading>

                <MousePointerWrapper>

                  <MousePointerInnerWrapperOne>
                    <ElementWrapper
                      width={'auto'}
                    >
                      CSS Selector
                    </ElementWrapper>

                    <ElementWrapper
                      width={'300px'}
                    >
                      <CvtInput 
                        mode={this.mode} 
                        type={"text"}
                      >
                      </CvtInput>
                    </ElementWrapper>

                    <ElementWrapper
                      width={'auto'}
                    >
                      <SelectCssButton
                        text={'Select'}
                        icon={''}
                        size={'md'}
                        mode={this.mode}
                        color={''}
                        prepend={true}
                        onClick={(event) => {}}
                      ></SelectCssButton>
                    </ElementWrapper>

                  </MousePointerInnerWrapperOne>

                  <MousePointerInnerWrapperTwo>

                    <ElementWrapper
                      width={'auto'}
                    >
                      <RadioGroup 
                        theme={''}
                        orientation={'vertical'}
                        size={'md'}
                        initialValue={'click_or_touch'}
                      >
                        <Radio
                          border={false} 
                          otherValue={'click_or_touch'}
                          onRadioClick={(val) => {}}
                        >
                          Click or touch
                        </Radio>
                        <Radio
                          border={false} 
                          otherValue={'hover_desktop_only'}
                          onRadioClick={(val) => {}}
                        >
                          Hover (Desktop only)
                        </Radio>
                        <Radio
                          border={false} 
                          otherValue={'out_desktop_only'}
                          onRadioClick={(val) => {}}
                        >
                          Out (Desktop only)
                        </Radio>
                      </RadioGroup>

                    </ElementWrapper>

                  </MousePointerInnerWrapperTwo>
                </MousePointerWrapper>

              </SpecificOptionContentWrapper>
            )}

            { this.triggerType === 'event' && (
              <SpecificOptionContentWrapper>

                <EventHeading>Immediately open campaign on event trigger</EventHeading>

                <EventWrapper>

                  <EventInnerWrapperOne>

                    <EventInnerWrapperOneSubSectionOne>
                      <ElementWrapper
                        width={'auto'}
                      >
                        Convrrt Events
                      </ElementWrapper>

                      <ElementWrapper
                        width={'300px'}
                      >
                        <CvtInput 
                          mode={this.mode} 
                          type={"text"}
                        >
                        </CvtInput>
                      </ElementWrapper>
                    </EventInnerWrapperOneSubSectionOne>

                    <EventInnerWrapperOneSubSectionTwo>
                      <MinusButton
                        mode={this.mode.toLowerCase()}
                        color={this.mode.toLowerCase()}
                        shape={'pill'}
                        size={'sm'}
                        icon={'minus'}
                        icononly={true}
                        onClick={(event) => { } }
                      ></MinusButton>
                    </EventInnerWrapperOneSubSectionTwo>

                  </EventInnerWrapperOne>

                  <EventInnerWrapperTwo>

                    <EventInnerWrapperTwoSubSectionOne>
                      <PlusButton
                        mode={this.mode.toLowerCase()}
                        color={this.mode.toLowerCase()}
                        shape={'pill'}
                        size={'sm'}
                        icon={'plus'}
                        icononly={true}
                        onClick={(event) => { } }
                      ></PlusButton>
                    </EventInnerWrapperTwoSubSectionOne>
                    
                  </EventInnerWrapperTwo>

                  <EventInnerWrapperThree>

                    <ElementWrapper
                      width={'auto'}
                    >
                      <QuestionMarkButton
                        mode={this.mode.toLowerCase()}
                        color={this.mode.toLowerCase()}
                        shape={'pill'}
                        size={'md'}
                        icon={'question-circle'}
                        icononly={true}
                        onClick={(event) => { } }
                      ></QuestionMarkButton>
                    </ElementWrapper>

                    <ElementWrapper
                      width={'auto'}
                    >
                      Add Google Analytics Events
                    </ElementWrapper>

                  </EventInnerWrapperThree>

                </EventWrapper>

              </SpecificOptionContentWrapper>
            )}

          </SectionRightContentWrapper>

        </SectionWrapper>

        <SectionWrapper>
          <SectionLeftHeading>Placement</SectionLeftHeading>

          <SectionRightContentWrapper>
            <SectionRightContentHeading>Select where your campaign will be shown around the site</SectionRightContentHeading>

            <ElementWrapper>
              <cvt-radio-group 
                theme={"LIGHT"} 
                orientation={'horizontal'} 
                initialValue={this.placementType}
              >
                <cvt-radio-button 
                  size={"md"} 
                  value={'all-pages'} 
                  onRadioClick={(value) => this.onPlacementTypeChange(value)}
                >
                  All pages
                </cvt-radio-button>
                <cvt-radio-button 
                  size={"md"} 
                  value={'specific-pages'} 
                  onRadioClick={(value) => this.onPlacementTypeChange(value)}
                >
                  Specific pages
                </cvt-radio-button>

              </cvt-radio-group>
            </ElementWrapper>

            { this.placementType === 'specific-pages' && (
              <SpecificOptionContentWrapper>

                <PlacementTypeInnerWrapperOne>

                  <SpecificOptionHeading>Select where to show your campaign</SpecificOptionHeading>

                  <ElementWrapper
                    width={'auto'}
                  >
                    <RadioGroup 
                      theme={''}
                      orientation={'horizontal'}
                      size={'md'}
                      initialValue={'all-websites'}
                    >
                      <Radio
                        border={false} 
                        otherValue={'all-websites'}
                        onRadioClick={(val) => {}}
                      >
                        All Websites
                      </Radio>
                      <Radio
                        border={false} 
                        otherValue={'home-page'}
                        onRadioClick={(val) => {}}
                      >
                        Home Page
                      </Radio>
                      <Radio
                        border={false} 
                        otherValue={'first-landing-page'}
                        onRadioClick={(val) => {}}
                      >
                        First Landing Page
                      </Radio>
                      <Radio
                        border={false} 
                        otherValue={'user-reaching-page-number'}
                        onRadioClick={(val) => {}}
                      >
                        User Reaching Page Number
                      </Radio>
                    </RadioGroup>

                  </ElementWrapper>
                </PlacementTypeInnerWrapperOne>

                <PlacementTypeInnerWrapperTwo>

                  <SpecificOptionHeading>Select where to show your campaign</SpecificOptionHeading>

                  <PlacementTypeAddImportWrapper>

                      <ImportLink
                        text={'Import'}
                        icon={''}
                        size={'md'}
                        mode={this.mode}
                        color={''}
                        prepend={true}
                        onClick={(event) => {}}
                      ></ImportLink>

                      <AddLink
                        text={'Add'}
                        icon={''}
                        size={'md'}
                        mode={this.mode}
                        color={''}
                        prepend={true}
                        onClick={(event) => {}}
                      ></AddLink>

                      <PlusButton
                        mode={this.mode.toLowerCase()}
                        color={this.mode.toLowerCase()}
                        shape={'pill'}
                        size={'sm'}
                        icon={'plus'}
                        icononly={true}
                        onClick={(event) => { } }
                      ></PlusButton>

                  </PlacementTypeAddImportWrapper>

                </PlacementTypeInnerWrapperTwo>

              </SpecificOptionContentWrapper>
            )}

          </SectionRightContentWrapper>

        </SectionWrapper>

        <SectionWrapper>
          <SectionLeftHeading>Frequency</SectionLeftHeading>

          <FrequencyTypeWrapper>

            <SectionRightContentHeading>Select the number of times a visitor will see your campaign</SectionRightContentHeading>

            <cvt-radio-group 
              theme={"LIGHT"} 
              orientation={'horizontal'} 
              initialValue={'once-per-page-load'}
            >
              <cvt-radio-button 
                size={"md"} 
                value={'once-per-page-load'}
                onRadioClick={(value) => this.onFrequencyTypeChange(value)} >
                  Once per page load
                </cvt-radio-button>
              <cvt-radio-button 
                size={"md"} 
                value={'advanced'}
                onRadioClick={(value) => this.onFrequencyTypeChange(value)} >
                  Advanced
              </cvt-radio-button>
            </cvt-radio-group>


            { this.frequencyType === 'advanced' && (
              <SpecificOptionContentWrapper>

                <SpecificOptionHeading>Show advance rules for your campaign</SpecificOptionHeading>

                <SpecificOptionInnerWrapper>

                  <SpecificOptionSelectInnerWrapper>

                    <ElementWrapper
                      width={'200px'}
                    >
                      <cvt-select 
                        value={'show-again-after'}
                        label={""} 
                        helpText={""}
                        multiple={false}
                        mode={'dropdown'}
                        backgroundMode={this.mode}
                        selectDisabled={false}
                        floatingLabel={true}
                        onInput={() => {}}
                      >
                        <option value={"show-again-after"}>Show again after</option>
                        <option value={"lorem-ipsum"}>Lorem Ipsum</option>
                        <option value={"dollar-sit"}>Dollar Sit</option>
                      </cvt-select>
                    </ElementWrapper>
                    
                    <ElementWrapper
                      width={'100px'}
                    >
                      <cvt-select 
                        value={'5'}
                        label={""} 
                        helpText={""}
                        multiple={false}
                        mode={'dropdown'}
                        backgroundMode={this.mode}
                        selectDisabled={false}
                        floatingLabel={true}
                        onInput={() => {}}
                      >
                        <option value={"5"}>5</option>
                        <option value={"4"}>4</option>
                        <option value={"3"}>3</option>
                      </cvt-select>
                    </ElementWrapper>

                    <ElementWrapper
                      width={'auto'}
                    >
                      Day(s)
                    </ElementWrapper>

                  </SpecificOptionSelectInnerWrapper>

                  <SpecificOptionPlusBtnInnerWrapper>
                    
                    <PlusButton
                      mode={this.mode.toLowerCase()}
                      color={this.mode.toLowerCase()}
                      shape={'pill'}
                      size={'sm'}
                      icon={'plus'}
                      icononly={true}
                      onClick={(event) => { } }
                    ></PlusButton>

                  </SpecificOptionPlusBtnInnerWrapper>

                </SpecificOptionInnerWrapper>

              </SpecificOptionContentWrapper>
            )}

          </FrequencyTypeWrapper>

        </SectionWrapper>

      </MainWrapper>
    )
  }
}